import type NomenclatureExclusion from './NomenclatureExclusion';
import type NonAllowedOfficeHourSupplementRemark from './NonAllowedOfficeHourSupplementRemark';
import type OnceADayGroupRemark from './OnceADayGroupRemark';
import type OncePerIterationRemark from './OncePerIterationRemark';
import type OncePerNrCalendarYearsGroupRemark from './OncePerNrCalendarYearsGroupRemark';
import OrderInvoiceTuple from './OrderInvoiceTuple';
import type RecentOrder from './RecentOrder';
import type TooMuchNonAmountSupplementRemark from './TooMuchNonAmountSupplementRemark';

export class InvoiceRemarks {
    Exclusions: NomenclatureExclusion[];
    OnceADayRemarks: OncePerIterationRemark[];
    OnceADayGroupRemarks: OnceADayGroupRemark[];
    OncePerNrCalendarYearsRemarks: OncePerIterationRemark[];
    OncePerNrCalendarYearsGroupRemarks: OncePerNrCalendarYearsGroupRemark[];
    OncePerNrOfMonthsRemarks: OncePerIterationRemark[];
    HadForfait: OrderInvoiceTuple;
    HadConsultance: OrderInvoiceTuple;
    HadSupplement: OrderInvoiceTuple;
    HadNomenclatureWithAgeOutOfRange: boolean;
    HasHigherAmountSupplement: OrderInvoiceTuple;
    MultiplePercentageOrCalculated: TooMuchNonAmountSupplementRemark[];
    MultipleCustomAmountSupplements: boolean;
    RecentOrders: RecentOrder[];
    NonAllowedOfficeHourSupplementRemarks: NonAllowedOfficeHourSupplementRemark[];
    HadReducedSupplement: number;
    OrphanedNomenclatureNumbers: string[];

    constructor(exclusions: NomenclatureExclusion[], onceADayRemarks: OncePerIterationRemark[], onceADayGroupRemarks: OnceADayGroupRemark[],
        oncePerNrCalendarYearsRemarks: OncePerIterationRemark[], oncePerNrCalendarYearsGroupRemarks: OncePerNrCalendarYearsGroupRemark[],
        oncePerNrOfMonthsRemarks: OncePerIterationRemark[], hadForfait: OrderInvoiceTuple, hadConsultance: OrderInvoiceTuple,
        hadSupplement: OrderInvoiceTuple, hadNomenclatureWithAgeOutOfRange: boolean, hasHigherAmountSupplement: OrderInvoiceTuple,
        multiplePercentageOrCalculated: TooMuchNonAmountSupplementRemark[], multipleCustomAmountSupplements: boolean, recentOrders: RecentOrder[],
        nonAllowedOfficeHourSupplementRemarks: NonAllowedOfficeHourSupplementRemark[], hadReducedSupplement: number, orphanedNomenclatureNumbers: string[]) {
        this.Exclusions = exclusions;
        this.OnceADayRemarks = onceADayRemarks;
        this.OnceADayGroupRemarks = onceADayGroupRemarks;
        this.OncePerNrCalendarYearsRemarks = oncePerNrCalendarYearsRemarks;
        this.OncePerNrCalendarYearsGroupRemarks = oncePerNrCalendarYearsGroupRemarks;
        this.OncePerNrOfMonthsRemarks = oncePerNrOfMonthsRemarks;
        this.HadForfait = hadForfait;
        this.HadConsultance = hadConsultance;
        this.HadSupplement = hadSupplement;
        this.HadNomenclatureWithAgeOutOfRange = hadNomenclatureWithAgeOutOfRange;
        this.HasHigherAmountSupplement = hasHigherAmountSupplement;
        this.MultiplePercentageOrCalculated = multiplePercentageOrCalculated;
        this.MultipleCustomAmountSupplements = multipleCustomAmountSupplements;
        this.RecentOrders = recentOrders;
        this.NonAllowedOfficeHourSupplementRemarks = nonAllowedOfficeHourSupplementRemarks;
        this.HadReducedSupplement = hadReducedSupplement;
        this.OrphanedNomenclatureNumbers = orphanedNomenclatureNumbers;
    }
}
